import React, { useMemo } from 'react';
import { Line } from '@ant-design/plots';
import { Layout } from 'antd';
import dayjs from 'dayjs';


const DailyUserCountChart = ({ data, theme = 'classicDark', chartHeight = 400 }) => {
    
    const chartData = useMemo(() => {
        if (!data || data.length === 0) return [];
        
        return data.map(item => ({
            date: item.eventDate,
            dailyUsers: item.dailyUserCount,
        }));
    }, [data]);

    const config = {
        theme,
        data: chartData,
        height: chartHeight,
        xField: 'date',
        yField: 'dailyUsers',
        
        color: '#2793F6',

        axis: {
            x: {
                title: 'Date',
                labelFormatter: (date) => dayjs(date).format('MM/DD'),
                titleStyle: { fill: '#fff' },
                labelStyle: { fill: '#fff' },
                tickCount: 10,
            },
            y: {
                title: 'No of Users',
                titleStyle: { fill: '#fff' },
                labelStyle: { fill: '#fff' },
            },
        },
        
        // Line styling
        line: {
            style: {
                lineWidth: 2,
            },
        },
        
        
        tooltip: {
            showTitle: true,
            title: (d) => dayjs(d.date).format('YYYY-MM-DD'), 
            formatter: (datum) => {
                return {
                    name: 'Daily Users',
                    value: `${datum.dailyUsers.toLocaleString()}`,
                };
            },
        },
        
        legend: false, 
        
        
        point: {
            size: 4,
            style: {
                fill: '#2793F6',
            },
        },
    };
    
    if (chartData.length === 0) {
        return <Layout style={{ height: chartHeight, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>No daily user data available for this period.</Layout>;
    }

    return <Line {...config} />;
};

export default DailyUserCountChart;